export const descriptionStrengthLevels = {
    Empty: {
      title: '',
      color: '',
      text: '',
    },
    Low: {
      title: 'Low',
      color: 'red',
      text: "Your description could use a little more detail. Tell us as much as you can about the symptoms you're experiencing.",
    },
    Average: {
      title: 'Good',
      color: '#F2C01B',
      text: 'Good description! If you can provide more details, that would be great. If not, no problem.',
    },
    High: {
      title: 'Excellent',
      color: '#A6E177',
      text: 'This is a very detailed description. All this information makes our work much easier.',
    },
  };